export default __webpack_public_path__ + "static/media/warning2.d7bdc879.svg";